import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import FinautaLogo from '../../images/svgs/finauta/logo.svg';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { breakpoints } from '../../constants/styles';
import PoliglotLink from '../PoliglotLink';
import { poliglotLink } from '../../classes/poliglotlink';
import { mq } from '../../styles/theme';

const StyledLogo = styled.div`
  position: ${({ position }) => position};
  top: 10px;
  left: 10px;

  ${breakpoints.desktop} {
    top: 30px;
    left: 30px;
  }

  ${({ inline }) =>
    inline &&
    css`
      position: relative;
      display: inline-block;
      top: 0.1em !important;
      left: 0 !important;
      right: 0;
      bottom: 0;
      margin: 0.2em 0.3em 0 0.2em;
    `}
`;

const Image = styled.img.attrs(({ src }) => src)`
  height: 35px;
  margin-left: 5px;

  ${mq.md} {
    height: 45px;
    margin-left: 15px;
  }

  ${({ inline }) =>
    inline &&
    css`
      width: 4em !important;
    `}
`;

const Logo = ({ white, width, inline, position, top, left, style }) => (
  <PoliglotLink to={new poliglotLink('https://www.finauta.com', false, false)} style={style}>
    <StyledLogo inline={inline} position={position} top={top} left={left}>
      <Image src={white ? FinautaWhiteLogo : FinautaLogo} inline={inline} width={width} id="logo" />
    </StyledLogo>
  </PoliglotLink>
);

Logo.propTypes = {
  white: PropTypes.bool,
  width: PropTypes.number,
  inline: PropTypes.bool,
  position: PropTypes.string,
  top: PropTypes.number,
  left: PropTypes.number,
};

Logo.defaultProps = {
  white: false,
  width: null,
  inline: false,
  position: '',
  top: 10,
  left: 10,
};

export default Logo;
